import React, { useState } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default function ExportReportModal({ items, onClose }) {
  const [exportAll, setExportAll] = useState(true);
  const [exportStartDate, setExportStartDate] = useState('');
  const [exportEndDate, setExportEndDate] = useState('');
  const [exportInvestment, setExportInvestment] = useState('');
  const [exportLeverage, setExportLeverage] = useState('');
  const [exportType, setExportType] = useState('closed'); // Options: 'closed', 'ongoing', 'alerts'


  const handleGeneratePdf = () => {
    const start = exportStartDate ? new Date(exportStartDate + 'T00:00:00') : null;
    const end = exportEndDate ? new Date(exportEndDate + 'T23:59:59') : null;

const filtered = items.filter(item => {
  const date = new Date(item.addedAt);

  if (!exportAll) {
    if (start && date < start) return false;
    if (end && date > end) return false;
  }

  // Apply type filter
if (exportType === 'closed' && item.closed !== true) return false;
if (exportType === 'ongoing' && item.closed === true) return false;
if (exportType === 'alerts' && (!Array.isArray(item.alertTargets) || item.alertTargets.length === 0)) return false;


  return true;
});


    const investment = parseFloat(exportInvestment) || 0;
    const leverage = parseFloat(exportLeverage) || 1;
    const totalInvested = investment * filtered.length;
    let totalGain = 0;

    const tableBody = filtered.map(item => {
      const rec = item.recommendation?.toUpperCase() || '';
      const isLong = rec === 'BUY' || rec === 'STRONG BUY';
      const entry = isLong ? item.longPosition?.entry : item.shortPosition?.entry;
      const latest = item.latestPrice ?? entry;
      const tp = isLong ? item.longPosition?.tp : item.shortPosition?.tp;
      const sl = isLong ? item.longPosition?.sl : item.shortPosition?.sl;

      let pl = '–';
      let gain = '–';

      if (entry != null && latest != null) {
        const pct = isLong ? ((latest - entry) / entry) : ((entry - latest) / entry);
        pl = (pct * 100).toFixed(2);
        gain = (investment * leverage * pct).toFixed(2);
        totalGain += parseFloat(gain);
      }

      return [
        item.token,
        rec,
        entry?.toFixed(4) ?? '–',
        latest?.toFixed(4) ?? '–',
        tp?.toFixed(4) ?? '–',
        sl?.toFixed(4) ?? '–',
        pl,
        gain
      ];
    });

    const marginPercent = totalInvested > 0 ? ((totalGain / totalInvested) * 100).toFixed(2) + '%' : '–';

    const doc = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor('#00f7ff');
    doc.setFillColor(10, 11, 40);
    doc.rect(40, 40, 515, 30, 'F');
    const typeLabel = exportType === 'closed' ? 'Closed Trades'
                      : exportType === 'ongoing' ? 'Ongoing Positions'
                      : 'Alerts';

    doc.text(`TrendScout Portfolio Report — ${typeLabel}`, 50, 60);

    autoTable(doc, {
      startY: 80,
      head: [['Date', 'Per Trade', 'Leverage', 'Invested', 'Total Gain', 'Margin']],
      body: [[
        new Date().toLocaleString(),
        `$${investment}`,
        `x${leverage}`,
        `$${totalInvested.toFixed(2)}`,
        `$${totalGain.toFixed(2)}`,
        marginPercent
      ]],
      theme: 'grid',
      headStyles: {
        fillColor: [10, 11, 40],
        textColor: [0, 247, 255],
        halign: 'center'
      },
      bodyStyles: {
        textColor: [30, 31, 59],
        fontSize: 10,
        halign: 'center'
      },
      margin: { left: 40, right: 40 }
    });

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 20,
      head: [['Token', 'Type', 'Entry', 'Latest', 'TP', 'SL', 'P/L (%)', 'Gain ($)']],
      body: tableBody,
      theme: 'grid',
      headStyles: {
        fillColor: [10, 11, 40],
        textColor: [0, 247, 255],
        fontStyle: 'bold',
        fontSize: 11,
        halign: 'center',
      },
      bodyStyles: {
        textColor: [30, 31, 59],
        fontSize: 10,
        halign: 'center',
      },
      alternateRowStyles: {
        fillColor: [245, 245, 255],
      },
      didParseCell(data) {
        if (data.section === 'body' && (data.column.index === 6 || data.column.index === 7)) {
          const val = parseFloat(data.cell.raw);
          if (!isNaN(val)) {
            data.cell.styles.textColor = val >= 0 ? [0, 128, 100] : [200, 0, 0];
            data.cell.styles.fontStyle = 'bold';
          }
        }
      }
    });

    doc.save('TrendScout_Report.pdf');
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Export TrendScout Report</h3>
          <label>Export Type:</label>
          <select value={exportType} onChange={(e) => setExportType(e.target.value)}>
            <option value="closed">Closed</option>
            <option value="ongoing">Ongoing</option>
            <option value="alerts">Alerts</option>
          </select>

          <label>
            <input type="checkbox" checked={exportAll} onChange={(e) => setExportAll(e.target.checked)} />
            Export all documents (ignores date filter)
          </label>


        {!exportAll && (
          <>
            <label>From:</label>
            <input type="date" value={exportStartDate} onChange={(e) => setExportStartDate(e.target.value)} />
            <label>To:</label>
            <input type="date" value={exportEndDate} onChange={(e) => setExportEndDate(e.target.value)} />
          </>
        )}

        <label>Investment ($):</label>
        <input className='export-trade-input' type="number" value={exportInvestment} onChange={(e) => setExportInvestment(e.target.value)} />

        <label>Leverage (x):</label>
        <input className='export-trade-input' type="number" value={exportLeverage} onChange={(e) => setExportLeverage(e.target.value)} />

        <div className="modal-buttons">
          <button className='trade-export-button' onClick={handleGeneratePdf}>Download PDF</button>
          <button className='trade-export-button' onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
